import EmptyContent from "../../components/General/EmptyContent";
import { useEffect, useRef, useState } from "react";
import BreadCrumbs from "../../components/General/BreadCrumbs";
import SingleShowroomCard from "../../components/Showrooms/SingleShowroomCard";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import { useTranslation } from "../../hooks/useTranslation";
import { getServiceCentersFor, getShowroomsFor, ServiceCenterResource, ShowroomResource } from "../../utils/fetcher";
import { useScrollToTop } from "../../utils/generalUtils";
import style from "./index.module.css";
import { VehicleNames } from "../../utils/GeneralTypes";
import VehicleTypesControllers from "../../components/General/VehiclesControllers";

type ComponentDataT =
  | {
      isShowroom: true;
      centers: ShowroomResource[];
    }
  | {
      isShowroom: false;
      centers: ServiceCenterResource[];
    };

const Showrooms = ({ vehicleModule: { single: vehicleType }, isServiceCenter = false }: ComponentPropsType) => {
  const { locale } = useTranslation();

  const initialMount = useRef<boolean>(true);

  useScrollToTop();

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: ComponentDataT;
  }>({
    isFetching: true,
    data: {
      isShowroom: !isServiceCenter,
      centers: [],
    },
  });

  useEffect(() => {
    if (!initialMount.current) {
      setComponentData((current) => ({
        ...current,
        isFetching: true,
      }));
    }
    initialMount.current = false;
    (async () => {
      if (isServiceCenter) {
        const res = await getServiceCentersFor(vehicleType);
        setComponentData({
          isFetching: false,
          data: {
            isShowroom: false,
            // TODO: this filter used to only render service center that support the current vehicle type
            // but there's no UI to change the vehicle type
            centers: res.data.service_centers.filter((center: any) => center[vehicleType] === 1),
          },
        });
      } else {
        const res = await getShowroomsFor(vehicleType);
        setComponentData({
          isFetching: false,
          data: {
            isShowroom: true,
            centers: res.data.showrooms.data,
          },
        });
      }
    })();
  }, [vehicleType, isServiceCenter]);

  return (
    <>
      {/* <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <BreadCrumbs
              pages={[
                { text: locale("home"), link: "/" },
                {
                  text: locale(isServiceCenter ? "service_centers" : "showrooms"),
                  link: "",
                },
                {
                  text: locale(vehicleType),
                  link: "",
                },
              ]}
            />
          </div>
        </div>
      </div> */}
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <div className={style.section_header}>
              <h3 className="main_section__title main_section__title--center">
                {locale(isServiceCenter ? "service_centers" : "showrooms")}
              </h3>
              <VehicleTypesControllers
                baseLink={`/${isServiceCenter ? "service-centers" : "showrooms"}`}
                active={vehicleType}
              />
            </div>

            {!componentData.isFetching && componentData.data.centers.length === 0 ? (
              <div className="col-12">
                <EmptyContent>
                  <p>{locale("noResult")}</p>
                </EmptyContent>
              </div>
            ) : null}
            <div className={style.section_centers}>
              {((!componentData.isFetching && componentData.data.centers?.length > 0) || componentData.isFetching) &&
                (componentData.isFetching ? (
                  <LoadingSkeleton count={5} />
                ) : (
                  <div className={`${style.section_centers__row} row`}>
                    {componentData.data.centers.map((center) => (
                      <div key={center.id} className="col-md-4 col-sm-6">
                        <SingleShowroomCard
                          name={center.name}
                          image={center.logo}
                          link={`/${isServiceCenter ? "service-centers/center" : "showrooms/showroom"}/${center.id}`}
                          location={!componentData.data.isShowroom ? (center as ServiceCenterResource).address : ""}
                          {...(componentData.data.isShowroom
                            ? {
                                // types: vehicleConditions.reduce(
                                //   (acc, cur, index) =>
                                //     center[cur]
                                //       ? acc + `${index !== 0 && acc !== "" ? " - " : ""}${locale(cur as LocalesKeys)}`
                                //       : acc,
                                //   "",
                                // ),
                              }
                            : {})}
                          {...(!componentData.data.isShowroom
                            ? {
                                notes: [
                                  [locale("working_hours"), (center as ServiceCenterResource).working_hours],
                                  [locale("days_off"), (center as ServiceCenterResource).days_off],
                                ],
                              }
                            : {})}
                        />
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Showrooms;

type ComponentPropsType = {
  vehicleModule: VehicleNames;
  isServiceCenter?: boolean;
};
